import axios from "axios";
import React, { useEffect, useState } from "react";
import { Motorista } from "../../../Models/Cadastros/Motorista/Motorista";
import { useSnackbar } from "notistack";
import PopupBasePage from "../../../Components/Base/BasePopup";
import TabHeaderComponent from "../../../Components/Navigations/SimpleTabHeaderComponent";
import TabPanelComponent from "../../../Components/Navigations/SimpleTabPanelComponent";
import MotoristaDadosTab from "./MotoristaDadosTab";

const MotoristaCadastroPopup = (props: any) => {
    const [tabValue, setTabValue] = React.useState(0);
    const [motorista, setMotorista] = useState<any>(new Motorista());
    const [perfis, setPerfis] = useState<any[]>([]);
    const [tecnologias, setTecnologias] = useState<any[]>([]);
    const { enqueueSnackbar } = useSnackbar();

    useEffect(() => {
        (async () => {
            if ((props.motorista?.id ?? 0) != 0) {
                setMotorista(props.motorista);
            }

            let responsePerfis: any = await axios.get('perfis');
            setPerfis(responsePerfis.data);

            let responseTecnologia: any = await axios.get(`buscaTecnologias`);
            setTecnologias(responseTecnologia.data);
        })();
    }, []);
    
    async function save() {
        try {
            let responseId: any = null;
            if (motorista?.id == null ||motorista?.id == 0 || motorista?.id == '') {
                let response = await axios.post('motoristas', motorista);
                responseId = response.data.motorista_id;
            }
            else {
                let response = await axios.put(`motoristas/${motorista.id}`, motorista);
                responseId = response.data.motorista_id;
            }

            enqueueSnackbar('Salvo com sucesso!', {variant: 'success'});
            let responseMotorista: any = await axios.get(`buscaPorMotoristaId?id=${responseId}`);
            setMotorista(responseMotorista.data);
        } catch (error) {
            enqueueSnackbar('Erro ao salvar!', {variant: 'error'});
        }
        finally {
            document.body.style.cursor = "default";
        }
    }
    
    return (
        <PopupBasePage title="Motorista" isOpen={props.isOpen} onClose={props.onClose} onClickFirstButtonPopupCallback={save} isPesquisa='false' confirmClose={true}>
            <div className="container">
                <div className="row">
                    <div className="align-all-left col-md-12 order-md-1">
                        <TabHeaderComponent setTabValueEventCallBack={setTabValue} label="Cadastro Motorista" tabs={['Dados', 'Operações', 'Histórico']} tab="motorista" />

                        <form className="needs-validation" id="formMotoristaDados">
                            <TabPanelComponent value={tabValue} index={0} tab="motorista" tabHeader="motorista">
                                <MotoristaDadosTab motorista={motorista} />
                            </TabPanelComponent>
                        </form>

                        <TabPanelComponent value={tabValue} index={1} tab="motorista" tabHeader="motorista">
                            {/* <MotoristaFiltroAcessosTab motorista={motorista} /> */}
                        </TabPanelComponent>

                        <TabPanelComponent value={tabValue} index={4} tab="painel" tabHeader="motorista">
                            {/* <MotoristaPaineis motorista={motorista} /> */}
                        </TabPanelComponent>
                    </div>
                </div>
            </div >
        </PopupBasePage >
    );
}

export default MotoristaCadastroPopup;